import { http } from './config'

export default {
  listandoEnderecos:(cd) => {
    return http.get('endereco_raio.php?cd_usu='+cd);
  }
}